// extracted by mini-css-extract-plugin
export default {"cls1":"VeloList-VeloListItemMeta_cls1__27Cdu","cls2":"VeloList-VeloListItemMeta_cls2__N+e2u VeloList-VeloListItemMeta_cls1__27Cdu"};